var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('list-item',{attrs:{"title":_vm.$t('seller.products.entrega_arquivos.text_1896'),"list":_vm.list},on:{"delete":_vm.removeFile}}):_c('div',{staticClass:"container-loading"},[_c('b-spinner',{attrs:{"label":"Loading..."}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }